<div class="container">
  @for (unit of data(); track unit[0]) {
    <div
      class="time-unit"
      pRipple
      [ngClass]="{ 'time-unit--active': unit[1].active }"
      (click)="handleClick(unit[0], !unit[1].active)"
    >
      {{ unit[1].label }}
    </div>
  }
</div>
